<script setup>
defineProps({
    profile: {
        type: Object,
        required: true,
    },
    activeTabIndex: {
        type: Number,
        default: 0,
    },
})
</script>

<template>
    <section class="mural-profile">
        <div class="mural-profile__cover">
            <button class="mural-profile__update" type="button" v-tooltip="$t('common.labels.availableSoon')">
                <span class="material-symbols-outlined">photo_camera</span>
                {{ $t('components.rhdigital.mural.profile.update') }}
            </button>
        </div>

        <div class="mural-profile__content">
            <div class="mural-profile__identity">
                <span class="mural-profile__avatar">
                    <img :src="profile.avatar" :alt="profile.name">
                    <span class="mural-profile__status"></span>
                </span>

                <div>
                    <h1 class="text-capitalize mb-2">{{ profile.name }}</h1>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.mural-profile {
    overflow: hidden;
    border: 1px solid #dde5f3;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 12px 30px rgba(34, 48, 73, 0.04);

    &__cover {
        position: relative;
        height: 128px;
        background:
            radial-gradient(circle at 24% 8%, rgba(255, 255, 255, 0.24), transparent 28%),
            linear-gradient(115deg, #f70bc6 0%, #ff6416 28%, #04d2dd 63%, #3482dd 100%);
    }

    &__update {
        position: absolute;
        top: 10px;
        right: 10px;
        display: inline-flex;
        align-items: center;
        gap: 5px;
        height: 24px;
        padding: 0 10px;
        border: 0;
        border-radius: 7px;
        background: rgba(255, 255, 255, 0.88);
        color: #34506f;
        font-size: 12px;
        font-weight: 600;
        cursor: default;

        .material-symbols-outlined {
            font-size: 15px;
        }
    }

    &__content {
        position: relative;
        padding: 0 16px 16px;
    }

    &__identity {
        display: flex;
        align-items: flex-end;
        gap: 16px;
        min-height: 62px;
    }

    &__avatar {
        position: relative;
        display: inline-flex;
        width: 80px;
        height: 80px;
        margin-top: -33px;
        border: 4px solid #fff;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 10px 25px rgba(50, 68, 99, 0.14);

        img {
            width: 100%;
            height: 100%;
            border-radius: inherit;
            object-fit: cover;
        }
    }

    &__status {
        position: absolute;
        right: 2px;
        bottom: 7px;
        width: 11px;
        height: 11px;
        border: 2px solid #fff;
        border-radius: 50%;
        background: #18c56f;
    }

    h1 {
        margin: 0;
        color: #2f3b52;
        font-size: 20px;
        font-weight: 800;
        line-height: 1.15;
    }

    p {
        margin: 4px 0 0;
        color: #8ea0bb;
        font-size: 13px;
        font-weight: 500;
    }
}

.dark-theme {
    .mural-profile {
        border-color: var(--borderColor);
        background: #0c1427;
        box-shadow: none;

        &__update {
            background: rgba(12, 20, 39, 0.82);
            color: var(--whiteColor);
        }

        &__avatar {
            border-color: #0c1427;
            background: #0c1427;
            box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28);
        }

        &__status {
            border-color: #0c1427;
        }

        h1 {
            color: var(--whiteColor);
        }

        p {
            color: var(--bodyColor);
        }

        &__tab {
            color: var(--bodyColor);

            &--active {
                color: #fff;
            }
        }
    }
}

@media (max-width: 575px) {
    .mural-profile {
        &__cover {
            height: 112px;
        }

        &__identity {
            align-items: center;
        }

        &__avatar {
            width: 68px;
            height: 68px;
            margin-top: -26px;
        }

        h1 {
            font-size: 18px;
        }
    }
}
</style>
